import HttpService from '@/shared/services/HttpService';

class UserService {
    private http = new HttpService();
    public async fetchUser(username: string) {
        try {
            return this.http.get('users/' + username);
        } catch (e) {
            return e;
        }
    }

    public async fetchUserTransactions(accountId: number, nextPage: string) {
        const url = nextPage.substring(1) || `transaction_journals?itemsPerPage=5`;
        const response = await this.http.get(url);
        if (response) {
            return {
                items: response['hydra:member'],
                nextPage: response['hydra:view']['hydra:next'],
                previousPage: response['hydra:view']['hydra:previous']
            }
        }
    }

    public async updateUser(username: string, user: any) {
        return await this.http.put(`users/${username}`, user);
    }

    public async updatePassword(username: string, password: string) {
        return await this.http.patch(`users/${username}`, {
            password
        });
    }

    public async fetchUserInfo(username: string) {
        try {
            const response = await this.http.get('users/' + username);
            if (response) {
                // return response['hydra:member'].map((competition: any) => ({
                //     id: competition.id,
                //     name: competition.name,
                // }));
            }
        } catch (e) {
            return e;
        }
    }

}

export default new UserService();
